import gameConsts from './gameConsts';

let tileId;
let randItems = [];
const HIDDEN_COLS = [2, 3, 4];
const INVERSE_TILE_LAST_ID = 3;
const DEFAULT_TILE_FIRST_ID = 4;
const DEFAULT_TILE_LAST_ID = DEFAULT_TILE_FIRST_ID + INVERSE_TILE_LAST_ID;

export default class Level {
  constructor({ game, road, name, signal }) {
    this._game = game;
    this._hiddenRows = gameConsts.LEVEL_VALUES.rows - gameConsts.LEVEL_VALUES.visibleRows;
    this._road = road;
    this._group = this._game.add.group();
    this._name = name;
    this.isActive = false;
    this._height = gameConsts.LEVEL_VALUES.rows * gameConsts.LEVEL_VALUES.tileSize;
    this._nextImagePic = this._game.cache.getFrameData('nfs').getFrameByName(gameConsts.LEVELS[this._name].nextImage);
    this._nextImage = this._game.add.sprite(0, -this._nextImagePic.height, 'nfs', gameConsts.LEVELS[this._name].nextImage);
    this._nextImageHeight = this._nextImagePic.height;

    this._bottomImage = this._game.add.sprite(0, 0, 'nfs', gameConsts.LEVELS[this._name].bottomImage);
    this._bottomImagePic = this._game.cache.getFrameData('nfs').getFrameByName(gameConsts.LEVELS[this._name].bottomImage);

    this._currentRow = 0; // текущая строка, используется для определения координаты уровня
    this._currentRowId = 0; // для определения итемов текущей нижней строки (через индексы)
    this._currentIteration = 0; // для определения круга показа уровня
    this.maxIterations = 1; // макс количество кругов показа уровня

    this._signal = signal;
  }
  // eslint-disable-next-line
  get _scaleValue() {
    return window.innerWidth <= gameConsts.WINDOW_SCALING_WIDTH ? gameConsts.LEVEL_VALUES.scaleXs : gameConsts.LEVEL_VALUES.scale;
  }
  get _groupY() {
    return this._group.getBounds().y;
  }
  get _isInScreen() {
    return this._groupY >= (-gameConsts.LEVEL_VALUES.tileSize * this._hiddenRows) && this._groupY < (gameConsts.GAME_HEIGHT + gameConsts.LEVEL_VALUES.tileSize);
  }
  get _isAboveScreen() {
    return this._groupY >= gameConsts.GAME_HEIGHT;
  }
  get _bottomItems() {
    return this._group.filter((child, index) =>
      index >= gameConsts.LEVEL_VALUES.cols * this._currentRowId && index < gameConsts.LEVEL_VALUES.cols * (this._currentRowId + 1));
  }
  get _randomFrame() {
    return this._game.rnd.integerInRange(0, gameConsts.LEVELS[this._name].types - 1);
  }
  _createRows(create) {
    for (let i = 0; i < gameConsts.LEVEL_VALUES.rows; i += 1) {
      const y = gameConsts.LEVEL_VALUES.tileSize * i;
      this._createRow(create, y, i);
    }
    this._group.reverse(); // формируем группу от большего индекса к меньшему (сверху вниз)
  }
  _createRow(create, y, rowIndex) {
    for (let i = 0; i < gameConsts.LEVEL_VALUES.cols; i += 1) {
      if (create) {
        if (HIDDEN_COLS.includes(i)) {
          tileId = gameConsts.LEVELS[this._name].types - 1;
        } else if (this._name === 'level3') {
          if (i === 0) {
            randItems = [DEFAULT_TILE_FIRST_ID, DEFAULT_TILE_LAST_ID];
          } else if (i === gameConsts.LEVEL_VALUES.cols - 1) {
            randItems = [0, INVERSE_TILE_LAST_ID];
          } else {
            randItems = [DEFAULT_TILE_LAST_ID + 1, gameConsts.LEVELS[this._name].types - 1];
          }
          tileId = this._game.rnd.integerInRange(...randItems);
        } else {
          tileId = this._randomFrame;
        }
        this._group.create(gameConsts.LEVEL_VALUES.tileSize * i, y, 'nfs', `${this._name}-${tileId}.jpg`);
      } else {
        const child = this._group.getChildAt((rowIndex * gameConsts.LEVEL_VALUES.cols) + i); // резет
        child.position.y = y;
      }
    }
  }
  _swapRows() {
    if (this._group.position.y >= gameConsts.LEVEL_VALUES.tileSize * ((this._currentRow - this._hiddenRows) + 1)) {
      this._bottomItems.list.forEach((item) => {
        // eslint-disable-next-line
        item.position.y = -gameConsts.LEVEL_VALUES.tileSize * this._currentRow;
      });
      if (this._currentRowId >= gameConsts.LEVEL_VALUES.rows - 1) {
        this._activateOtherLevel();

        this._currentRowId = 0;
        this._currentIteration += 1;
      }
      this._currentRow += 1;
      this._currentRowId += 1;
    }
  }
  _moveGroup() {
    this._group.position.y += this._road.speed;
  }
  _activateOtherLevel() {
    if (this._currentIteration === this.maxIterations) {
      this._signal.dispatch(this._name);
      this.isActive = false;
    }
  }
  _moveNextImage() {
    this._nextImage.position.y += this._road.speed;
  }
  _createBottomImage() {
    if (this._bottomImage.position.y < 0) {
      this._moveBottomImage();
    }
  }
  _moveBottomImage() {
    this._bottomImage.position.y += this._road.speed;
  }
  scaleItem() {
    ['_nextImage', '_bottomImage'].forEach((item) => {
      this[item].scale.x = this._scaleValue;
      this[item].position.x = (gameConsts.GAME_WIDTH - (this._scaleValue * this[`${item}Pic`].width)) / 2;
    });
  }
  create() {
    this._createRows(true);
    this._game.world.sendToBack(this._group); // убираем фон под дорогу
    this._group.position.y = this.isActive ? -gameConsts.LEVEL_VALUES.tileSize * this._hiddenRows : -this._height;
    this._group.position.x = -20;
    this._bottomImage.sendToBack();
  }
  update() {
    if (this.isActive) {
      this._moveGroup(); // едем
      this._swapRows(); // перемещаем наверх ряды
      this._createBottomImage();
    } else if (this._isAboveScreen) {
      this._group.position.y = -this._height;
      this._createRows(false);// сбрасываем позиции тайлов через резетроус
      this._currentRow = 0;
      this._currentRowId = 0;// сбрасываем все значения
      this._currentIteration = 0;
      this._nextImage.position.y = -this._nextImageHeight;
      this._bottomImage.position.y = -gameConsts.GAME_HEIGHT - gameConsts.LEVEL_VALUES.tileSize;
    } else if (this._isInScreen) {
      this._moveNextImage();
      this._moveGroup(); // только едем
      if (this._groupY >= -gameConsts.LEVEL_VALUES.tileSize) {
        this._moveBottomImage();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/Level.js